import TextInput from '@/components/refinedev/TextInput';
import Section from '@/components/surface/Section';

const DepartmentForm = () => {
  return (
    <div>
      <div className="max-w-xl flex flex-col gap-y-4">
        <Section title="Phòng ban" subtitle="Nhập thông tin phòng ban">
          <TextInput source="name" label="Tên phòng ban" />
        </Section>
      </div>
    </div>
  );
};

export const transformBeforeSave = data => {
  return data;
};

DepartmentForm.transformBeforeSave = transformBeforeSave;

export default DepartmentForm;
